export default __webpack_public_path__ + "static/media/bodyMap.580822ea.jpg";